import React, { useEffect } from 'react';
import { useContext } from 'react';
import './App.css';
import { blueIcon } from './components/map/blue_icon';
import DropPointsMap from './components/map/map';
import MarkerDetail from './components/search/marker_detail';
import SearchHeading from './components/search/search_heading';
import { AppWrapper, MainWrapper } from './components/wrappers/app_wrapper';
import { DropPointsWrapper } from './components/wrappers/drop_points_wrapper';
import { MapWrapper } from './components/wrappers/map_wrapper';
import { ContentWrapper } from './components/wrappers/content_wrapper';
import { Context } from './store/context';
import { getDropPoints } from './services/services';
import PropTypes from 'prop-types';

const maxRecords = 10;

function App({ isLoaded }) {
  const {
    map,
    activeMarkerId,
    bounds,
    dropPoints,
    dropPointsComplete,
    mapMarkers,
    setDroppointsComplete,
    setBounds,
    setLastCenter,
  } = useContext(Context);

  const LoadCompletePoints = async () => {
    const dropPointsResponse = await getDropPoints();
    setDroppointsComplete(dropPointsResponse || []);
  };

  useEffect(() => {
    if (isLoaded) {
      LoadCompletePoints();
    }
  }, [isLoaded]);

  useEffect(() => {
    mapMarkers.forEach((marker) => {
      if (marker.id === activeMarkerId) {
        new window.google.maps.event.trigger(marker, 'click');
      } else {
        const icon = blueIcon();
        marker.content = icon.element;
      }
    });
  }, [activeMarkerId]);

  const showingPoints = dropPoints.filter((point) => {
    let marker = mapMarkers.find((x) => x.id === point.id);
    if (marker) {
      const isInBounds = map?.getBounds()?.contains(marker.position);
      return isInBounds;
    }
    return false;
  });

  return (
    <>
      <MainWrapper>
        <SearchHeading isLoaded={isLoaded} />
        <AppWrapper>
          <ContentWrapper>
            <DropPointsWrapper>
              {showingPoints.slice(0, maxRecords).map((point, index) => {
                return (
                  <MarkerDetail
                    number={index + 1}
                    key={`${point.id}`}
                    id={`${point.id}`}
                    title={point.label}
                    direction={point.direccion}
                    schedule={point.horario}
                    phone={point.telefono}
                    lat={point.lat}
                    lng={point.lng}
                  ></MarkerDetail>
                );
              })}
              {showingPoints.length > maxRecords ? (
                <p
                  style={{
                    borderRadius: '10px',
                    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                    overflow: 'hidden',
                    margin: '10px',
                    cursor: 'pointer',
                    width: '95%',
                    position: 'relative',
                    textAlign: 'center',
                    padding: '20px 0px',
                  }}
                >
                  Mostrando {maxRecords} de {showingPoints.length} Puntos,{' '}
                  <br /> Por favor acerca el mapa a una localidad mas especifica
                  para visualizar los puntos que sean de tu interes
                </p>
              ) : (
                <></>
              )}
            </DropPointsWrapper>
          </ContentWrapper>
          <MapWrapper>
            <DropPointsMap
              dropPoints={dropPointsComplete}
              isLoaded={isLoaded}
              onBoundsChanged={() => {
                if (map) setLastCenter(map.getCenter());
                setBounds(bounds + 1);
              }}
            />
          </MapWrapper>
        </AppWrapper>
      </MainWrapper>
    </>
  );
}

App.propTypes = {
  isLoaded: PropTypes.bool,
};

export default App;
